function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  stroke: "#625AFF"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  strokeWidth: 1.728
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 0.864,
  y: 0.864,
  width: 32.272,
  height: 32.272,
  rx: 16.136
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(11.000000, 11.000000)",
  fill: "#625AFF",
  strokeWidth: 1.3824
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.93585642,5.6820977 C5.8891888,5.72849342 5.86214774,5.79540092 5.86214774,5.86523868 C5.86214774,5.93507644 5.8891888,6.00198395 5.93585642,6.04837966 L11.6057549,11.6647031 C11.6960372,11.7540758 11.8334232,11.7447967 11.913674,11.6437029 C11.9930526,11.5435858 11.985202,11.3882823 11.8949198,11.2989095 L6.40907488,5.86523868 L11.8944836,0.432056276 C11.9847659,0.342683478 11.9930526,0.187868303 11.9132379,0.0872628576 C11.8334232,-0.0138309634 11.695601,-0.0235984823 11.6053188,0.0662626918 L5.93585642,5.6820977 Z",
  id: "Shape-Copy-2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.43245565,6.0439811 C6.47912328,5.99758538 6.50616433,5.93067788 6.50616433,5.86084012 C6.50616433,5.79100236 6.47912328,5.72409485 6.43245565,5.67769914 L0.762557128,0.0613757492 C0.672274898,-0.027997049 0.534888895,-0.0187179061 0.454638024,0.0823759149 C0.375259445,0.182492984 0.383110073,0.337796535 0.473392304,0.427169333 L5.9592372,5.86084012 L0.47382845,11.2940225 C0.383546219,11.3833953 0.375259445,11.5382105 0.45507417,11.6388159 C0.534888895,11.7399098 0.672711044,11.7496773 0.762993274,11.6598161 L6.43245565,6.0439811 Z",
  id: "Shape-Copy-3"
})))));

var SvgClose = function SvgClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34 34",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close.d3ecb8cb.svg";
export { ForwardRef as ReactComponent };